function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70.394 19.239H57.605a25.606 25.606 0 0 0-25.578 25.578v38.367a25.606 25.606 0 0 0 25.578 25.578h12.789a25.606 25.606 0 0 0 25.578-25.578V44.817a25.606 25.606 0 0 0-25.578-25.578m.935 58.485a3.199 3.199 0 0 1 4.524 4.524l-9.591 9.592a3.197 3.197 0 0 1-4.525 0l-9.591-9.592a3.199 3.199 0 0 1 4.524-4.524l4.132 4.136V46.14l-4.132 4.136a3.199 3.199 0 0 1-4.524-4.524l9.591-9.592a3.197 3.197 0 0 1 4.525 0l9.591 9.592a3.199 3.199 0 0 1-4.524 4.524l-4.132-4.137V81.86z",
    className: "icon_svg__black",
    style: {
      fill: "#f99a24"
    }
  }));
};
export default SvgIcon;